<template>
  <div class="promotionGood" v-if="benefit.length > 0">
    <!-- <div style="background:#000000; height:1.2rem;text-align:center;line-height:0.6rem" >
        <div style="color:#FFFFFF;font-size:0.35rem;font-weight:bold;">好物·分享</div>
        <div style="color:#909090;font-size:0.22rem">会员专享 超低折扣 会员专享 超低折扣</div>
    </div> -->
    
    <div
      @click="handleClickDetail(item)"
      class="item acea-row row-between-wrapper"
      v-for="(item, index) in benefit"
      :key="index"
    >
      <div class="pictrue">
        <img :src="item.image" class="image" />
      </div>
      <div class="text">
        <div class="name line1">{{ item.storeName }}</div>
        <div class="sp-money acea-row">
          <div class="">
            <span>{{ item.storeInfo }}</span>
            <!-- <span class="num">{{ item.storeInfo }}</span> -->
          </div>
        </div>
        <div class="acea-row row-between-wrapper">
          <!-- <div class="money">日常价：￥{{ item.otPrice }}</div> -->
          <div class="money"></div>
          <div>&nbsp;</div>
          <!-- <div>仅剩：{{ item.stock }}{{ item.unitName }}</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { postOrderIsVip} from "@api/order";

export default {
  name: "PromotionGood",
  props: {
    benefit: {
      type: Array,
      default: () => []
    }
  },
  data: function() {
    return {};
  },
   methods: {

      handleClickDetail(itemChild){
            postOrderIsVip(1, {}).then(res => {
                const data = res.data;
                if(data==null){
                  this.$router.push({path: '/detail/1'});
                }else{
                  //会员
                  this.$router.push({path: '/detail/'+itemChild.id});
                }
            }).catch(err => {
                console.log(err);
            });
      },

   }
};
</script>
